<template>
    <b-card header="Contact Us">
        <b-row>
            <b-col>
                <b-form-group label="Select Topic" label-for="topic">
                    <b-select name="topic" id="topic" v-model="form.topic" @change="form.clearError('topic')">
                        <option value="">-- Select a Topic --</option>
                        <option value="check_in_out">Help with Check-in/Check-out</option>
                        <option value="other">All other questions</option>
                        <option value="payment">Payment</option>
                    </b-select>
                </b-form-group>

                <div v-if="form.topic" class="">
                    <div v-if="form.topic == 'payment'" class="text-center">
                        <h3>Please contact your Claimant with any payment related questions.</h3>
                    </div>

                    <div v-else>
                        <b-form-group label="How would you like to contact us?">
                            <b-form-radio-group id="type" v-model="form.type" name="type">
                                <b-form-radio value="phone">Phone Support</b-form-radio>
                                <b-form-radio value="email">Online Support</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>

                        <div v-if="form.type == 'phone'">
                            <h3 v-if="tag == 'ltcg'">Please call {{ supportNumber }}</h3>
                            <h3 v-else>Please call {{ supportNumber }}</h3>
                        </div>
                        <div v-if="form.type == 'email'">
                            <b-form @submit.prevent="submit()">
                                <b-form-group label="Subject" label-for="subject">
                                    <b-input type="text" max="255" name="subject" v-model="form.subject" required />
                                    <input-help :form="form" field="subject" text=""></input-help>
                                </b-form-group>
                                <b-form-group label="Message" label-for="body">
                                    <b-textarea
                                        name="body"
                                        :rows="3"
                                        v-model="form.body"
                                        required
                                    >
                                    </b-textarea>
                                    <input-help :form="form" field="body" text=""></input-help>
                                </b-form-group>

                                <b-button type="submit" variant="success">Submit</b-button>
                            </b-form>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
    export default {
        props: {
            supportNumber: String,
        },

        data: () => ({
            form: new Form({
                topic: '',
                body: '',
                type: '',
                subject: '',
                tag: '',
            }),
        }),
        
        computed: {
            tag() {
                return this.form.topic == 'check_in_out' ? 'jtr' : 'ltcg';
            }
        },

        methods: {
            submit() {
                this.form.tag = this.tag;

                this.form.post(`/contact`)
                    .then( ({ data }) => {
                        console.log(data);
                    })
                    .catch(e => {
                        console.log(e);
                    })
            },
        },
    }
</script>
